

/* eslint-disable no-new */
import Vue from 'vue';
import FastClick from 'fastclick';
import VueRouter from 'vue-router';
import App from './App';
import router from './router/index';
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(VueRouter);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin, {position: 'bottom'});
FastClick.prototype.focus = function (targetElement) {
if (targetElement.type !== 'number' && targetElement.value) {
targetElement.selectionStart = targetElement.selectionEnd = targetElement.value.length;
}

targetElement.focus();
};
FastClick.attach(document.body);

Vue.config.productionTip = false;

new Vue({
router,
render: h => h(App)
}).$mount('#app-box');



// WEBPACK FOOTER //
// ./src/main.js